import React from 'react';
import { NavLink } from 'react-router-dom';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';

const navTitle = (item) => {
  if (item.url === '' && item.title === 'Home') {
    return 'ホーム';
  }
  return item.title;
};

const NavItem = ({ item, lang }) => {
  const { settings } = config;
  const title = navTitle(item);

  if (isInternalURL(item.url) || item.url === '') {
    return (
      <NavLink
        to={item.url === '' ? '/' : item.url}
        key={item.url}
        className="item"
        activeClassName="active"
        exact={item.url === '' || item.url === `/${toBackendLang(lang)}`}
      >
        {title}
      </NavLink>
    );
  }

  return (
    <a
      href={item.url}
      key={item.url}
      className="item"
      rel="noopener noreferrer"
      target={settings.openExternalLinkInNewTab ? '_blank' : '_self'}
    >
      {title}
    </a>
  );
};

export default NavItem;

